<h3>{{ 'admin.recl.titre' | traduire }}
  <span class="badge-notif" *ngIf="nombreEnAttente > 0">{{ nombreEnAttente }}</span>
</h3>

<div class="filtres">
  <select [(ngModel)]="filtreType">
    <option value="">{{ 'admin.recl.tousTypes' | traduire }}</option>
    <option value="avis">{{ 'admin.recl.typeAvis' | traduire }}</option>
    <option value="reclamation">{{ 'admin.recl.typeReclamation' | traduire }}</option>
  </select>
  <select [(ngModel)]="filtreStatut">
    <option value="">{{ 'admin.recl.tousStatuts' | traduire }}</option>
    <option value="en_attente">{{ 'admin.recl.enAttente' | traduire }}</option>
    <option value="traitee">{{ 'admin.recl.traite' | traduire }}</option>
  </select>
</div>

<div class="liste-messages">
  <div class="message-carte" *ngFor="let r of listeFiltree" [class.traitee]="r.statut === 'traitee'">
    <div class="message-entete">
      <span class="type-tag" [class.reclamation]="r.type === 'reclamation'">
        {{ r.type === 'reclamation' ? ('⚠ ' + ('admin.recl.typeReclamation' | traduire)) : ('💬 ' + ('admin.recl.typeAvis' | traduire)) }}
      </span>
      <span class="date">{{ r.dateEnvoi | date:'dd/MM/yyyy HH:mm' }}</span>
    </div>
    <h4>{{ r.sujet }}</h4>
    <p class="auteur">{{ r.nom }} — {{ r.email }}</p>
    <p class="contenu">{{ r.message }}</p>
    <div class="actions">
      <button *ngIf="r.statut !== 'traitee'" (click)="marquerTraitee(r)">{{ 'admin.recl.marquerTraite' | traduire }}</button>
      <button class="danger" (click)="supprimer(r)">{{ 'admin.recl.supprimer' | traduire }}</button>
    </div>
  </div>

  <p *ngIf="listeFiltree.length === 0" style="color:#888;">{{ 'admin.recl.vide' | traduire }}</p>
</div>
